/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgot_SubmitInputs */

const cs_auth_forgot_submit = /** @type {(inputs: Auth_Forgot_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslat odkaz`)
};

const en_auth_forgot_submit = /** @type {(inputs: Auth_Forgot_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send reset link`)
};

/**
* | output |
* | --- |
* | "Send reset link" |
*
* @param {Auth_Forgot_SubmitInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_forgot_submit = /** @type {((inputs?: Auth_Forgot_SubmitInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgot_SubmitInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_forgot_submit(inputs)
	return cs_auth_forgot_submit(inputs)
});